import React, { FunctionComponent } from 'react';

export enum ProjectTabType {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

interface ProjectTabsProps {
  activeTab: ProjectTabType;
  setActiveTab: (tab: ProjectTabType) => void;
  activeCount: number;
  archivedCount: number;
}

const ProjectTabs: FunctionComponent<ProjectTabsProps> = ({
  activeTab,
  setActiveTab,
  activeCount,
  archivedCount
}) => {
  const isActive = (tab: ProjectTabType) => activeTab === tab;
  const getTabClassName = (tab: ProjectTabType) =>
    `project-tabs__tab ${isActive(tab) ? 'is-active' : ''}`;
  const getBadgeClassName = (tab: ProjectTabType) =>
    `project-tabs__badge ${isActive(tab) ? 'project-tabs__badge--active' : ''}`;

  return (
    <div className="project-tabs">
      <div className="project-tabs__container">
        <button
          className={getTabClassName(ProjectTabType.ACTIVE)}
          onClick={() => setActiveTab(ProjectTabType.ACTIVE)}
        >
          <span>Active</span>
          {activeCount > 0 && (
            <span className={getBadgeClassName(ProjectTabType.ACTIVE)}>
              {activeCount}
            </span>
          )}
        </button>
        <button
          className={getTabClassName(ProjectTabType.ARCHIVED)}
          onClick={() => setActiveTab(ProjectTabType.ARCHIVED)}
        >
          <span>Archived</span>
          {archivedCount > 0 && (
            <span className={getBadgeClassName(ProjectTabType.ARCHIVED)}>
              {archivedCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProjectTabs;